/**
 * Empty rig — disables auto-application entirely.
 *
 * Use when no specific playtest surface is active. The
 * PlaytestRigApplier sees enabled: false and skips all setup.
 */

import type { PlaytestRig } from '../environment/devConfig';

export const NO_RIG: PlaytestRig = {
  enabled: false,
  label: 'none',
  toolsToOpen: [],
  enableFrameJitterTracking: false,
  enableReactRenderTracking: false,
};
